import { ReactNode } from "react";
import { Card } from "react-bootstrap";
import "./MediaCard.css";

interface Props {
  id: string;
  title: string;
  icon?: JSX.Element;
  mainContent?: ReactNode;
}

export function MediaCard(props: Props) {
  return (
    <Card className="media-card">
      <div className="card-image">{props.icon}</div>
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text>{props.mainContent}</Card.Text>
      </Card.Body>
    </Card>
  );
}
